/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as msRest from "@azure/ms-rest-js";
import * as Models from "../models";
import * as Mappers from "../models/pharmacyContextMappers";
import * as Parameters from "../models/parameters";
import { PolandPharmacyRxAPIContext } from "../polandPharmacyRxAPIContext";

/** Class representing a PharmacyContext. */
export class PharmacyContext {
  private readonly client: PolandPharmacyRxAPIContext;

  /**
   * Create a PharmacyContext.
   * @param {PolandPharmacyRxAPIContext} client Reference to the service client.
   */
  constructor(client: PolandPharmacyRxAPIContext) {
    this.client = client;
  }

  /**
   * @param [options] The optional parameters
   * @returns Promise<Models.PharmacyContextAllForUserResponse>
   */
  allForUser(options?: Models.PharmacyContextAllForUserOptionalParams): Promise<Models.PharmacyContextAllForUserResponse>;
  /**
   * @param callback The callback
   */
  allForUser(callback: msRest.ServiceCallback<Models.PharmacyContextDtoPagedResult>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  allForUser(options: Models.PharmacyContextAllForUserOptionalParams, callback: msRest.ServiceCallback<Models.PharmacyContextDtoPagedResult>): void;
  allForUser(options?: Models.PharmacyContextAllForUserOptionalParams | msRest.ServiceCallback<Models.PharmacyContextDtoPagedResult>, callback?: msRest.ServiceCallback<Models.PharmacyContextDtoPagedResult>): Promise<Models.PharmacyContextAllForUserResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      allForUserOperationSpec,
      callback) as Promise<Models.PharmacyContextAllForUserResponse>;
  }
}

// Operation Specifications
const serializer = new msRest.Serializer(Mappers);
const allForUserOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "portal/pharmacy-context",
  queryParameters: [
    Parameters.filters,
    Parameters.sorts,
    Parameters.page,
    Parameters.pageSize
  ],
  responses: {
    200: {
      bodyMapper: Mappers.PharmacyContextDtoPagedResult
    },
    default: {}
  },
  serializer
};
